import * as types from "./types";

import {
  getCustomFieldListAxios,
  upsertCustomFieldsAxios,
  deleteCustomFieldsAxios
} from "./services";

export async function getCustomFieldsListAction({ commit }, {section, payload}) {
  commit(types.LOADING_CUSTOMFIELDS, section, true);
  try {
    const { data } = await  getCustomFieldListAxios(payload);
    commit(types.GET_CUSTOMFIELD_LIST, {section: section, fields: data});
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_CUSTOMFIELDS, section, false);
  }
}

export async function deleteCustomFieldsAction({ commit }, {section, payload}) {
  commit(types.LOADING_CUSTOMFIELDS, section, true);
  try {
    const { data } = await deleteCustomFieldsAxios(payload);
    commit(types.REMOVE_CUSTOMFIELD, {section: section, id: payload});
    return data;
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_CUSTOMFIELDS, section, false);
  }
}

export async function upsertCustomFieldsAction({ commit }, {section, payload}) {
  console.log("🚀 ~ upsertCustomFieldsAction ~ payload:", payload)
  commit(types.LOADING_CUSTOMFIELDS, section, true);
  try {
    const { data } = await upsertCustomFieldsAxios(payload);
    commit(types.UPSERT_CUSTOMFIELD, {section: section, fields: payload});
    return data;
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_CUSTOMFIELDS, section, false);
  }
}